import React, { useEffect, useMemo, useState } from "react";
import { apiCall } from "../../utils/apiService";
import { getApiDisplayBase } from "../../utils/apiDisplayBase";
import { buildSmsApiExamples } from "./messageApiExampleBuilders";
import MessageApiExamplesPanel from "./MessageApiExamplesPanel";
import SmsDeviceHeaderLayer from "./SmsDeviceHeaderLayer";

const SmsLayer = () => {
  const [alertMessage, setAlertMessage] = useState(null);
  const [spinner, setSpinner] = useState(false);
  const [data, setData] = useState({
    deviceId: "",
    token: null,
    mobile: "",
    message: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { isValid, messageText } = validated();
    if (!isValid) {
      setAlertMessage({ message: messageText, class: "danger" });
      hideAlert(2);
      return;
    }

    const token = data.token || localStorage.getItem("apiKey");
    const phone = String(data.mobile).trim();
    const bodyText = String(data.message || "").trim();

    setSpinner(true);
    try {
      const response = await apiCall({
        url: "send-message/sms",
        method: "POST",
        body: {
          deviceId: String(data.deviceId),
          to: phone,
          text: bodyText,
          token,
        },
      });

      setAlertMessage({
        message: response.msg || response.message || "Request completed.",
        class: response.success ? "success" : "danger",
      });
      if (response.success) {
        setData((prev) => ({
          ...prev,
          mobile: "",
          message: "",
        }));
      }
    } catch (error) {
      setAlertMessage({ message: error.message || "Could not send SMS.", class: "danger" });
    } finally {
      setSpinner(false);
      hideAlert(3);
    }
  };

  const validated = () => {
    if (!data.deviceId) {
      return { isValid: false, messageText: "Device is required!" };
    }
    if (!data.token && !localStorage.getItem("apiKey")) {
      return { isValid: false, messageText: "Token is required!" };
    }
    if (data.mobile === "" || data.mobile == null) {
      return { isValid: false, messageText: "Phone is required!" };
    }
    if (data.message === "" || data.message == null) {
      return { isValid: false, messageText: "Message is required!" };
    }
    return { isValid: true, messageText: "" };
  };

  const hideAlert = (sec = 1) => {
    setTimeout(() => {
      setAlertMessage(null);
      setSpinner(false);
    }, sec * 1000);
  };

  useEffect(() => {
    document.title = "SMS";
  }, []);

  const apiBase = getApiDisplayBase();
  const smsCodeExamples = useMemo(() => buildSmsApiExamples(apiBase), [apiBase]);

  return (
    <>
      <div className="card">
        <div className="card-body">
          <SmsDeviceHeaderLayer
            getHeaderData={(deviceId, apiKey) =>
              setData((prev) => ({ ...prev, deviceId, token: apiKey }))
            }
          />
          <div className="row g-0">
            <div className="col-md-6 mt-3 pe-md-3">
              <form className="border rounded" onSubmit={handleSubmit}>
                <div
                  className="p-3 text-white"
                  style={{
                    borderTopLeftRadius: "5px",
                    borderTopRightRadius: "5px",
                    background: "#26a69a",
                  }}
                >
                  Request test
                </div>
                <div className="row m-0 g-0 p-3">
                  <div className="alert alert-success" style={{ fontSize: "12px" }}>
                    Note: Use it wisely, not recommended to check bulk numbers
                  </div>
                  {alertMessage && (
                    <div className={`alert alert-${alertMessage.class}`} style={{ fontSize: "12px" }}>
                      {alertMessage.message}
                    </div>
                  )}
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Phone: 923037900571"
                    value={data.mobile}
                    onChange={(e) => setData({ ...data, mobile: e.target.value })}
                  />
                  <span style={{ fontSize: "10px", color: "gray" }}>
                    Mobile number with country code without +
                  </span>
                  <textarea
                    rows={5}
                    className="form-control mt-3"
                    placeholder="Type message here..."
                    value={data.message}
                    onChange={(e) => setData({ ...data, message: e.target.value })}
                  />
                  <div className="d-flex justify-content-center mt-3">
                    <button
                      type="submit"
                      className="btn btn-success"
                      style={{ background: "#26a69a" }}
                      disabled={spinner}
                    >
                      {spinner ? "Sending…" : "Send Message"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
            <div className="col-md-6 mt-3 ps-md-3">
              <MessageApiExamplesPanel examples={smsCodeExamples} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SmsLayer;
